import React, { useState, useEffect } from 'react';
import { StyleSheet, View, Image, TouchableOpacity } from 'react-native';
import { EditorState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import { MaterialCommunityIcons } from '@expo/vector-icons';
import CameraComponent from '../camera/Camera';
import PopUpInfo from '../popUpInfo';
import theme from '../../constants/theme.style.js';
import '../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

const styles = StyleSheet.create({
  container: {
    flex: 1,
    width: '100%',
    height: '100%',
    position: 'relative',
  },
  formContainer: {
    flex: 1,
    padding: 30,
    height: '100%',
  },
  tools: {
    backgroundColor: theme.WHITE_COLOR,
    flexDirection: 'row',
    justifyContent: 'center',
    height: 50,
    paddingLeft: 10,
    paddingRight: 10,
  },
  BottomTools: {
    width: '100%',
    height: theme.ICON_WIDTH * 3,
    position: 'absolute',
    bottom: theme.ICON_WIDTH * 4,
    borderTopColor: theme.GREY_LIGHT_COLOR,
    borderTopWidth: 1,
  },
  buttonContainer: {
    position: 'relative',
  },
  buttonDisabled: {
    backgroundColor: 'rgba(255,255,255,0.8)',
    width: theme.ICON_WIDTH,
    height: theme.ICON_WIDTH,
    margin: 15,
    position: 'absolute',
    top: 0,
  },
  icon: {
    width: theme.ICON_WIDTH,
    height: theme.ICON_WIDTH,
    margin: 15,
  },
  iconButton: {
    zIndex: 999,
    paddingRight: 10,
    paddingLeft: 10,
    textAlign: 'center',
  },
  boldButton: {
    fontWeight: 'bold',
  },
  italicButton: {
    fontStyle: 'italic',
  },
  underlineButton: {
    textDecorationLine: 'underline',
  },
  deleteAttachment: {
    height: 20,
    width: 70,
    backgroundColor: 'transparent',
    position: 'relative',
    zIndex: 9999,
  },
  deleteAttachmentIconContainer: {
    backgroundColor: '#fff',
    borderRadius: 40,
    position: 'absolute',
    right: -25,
    top: 0,
  },
  deleteAttachmentIcon: {
    color: '#f00',
    fontSize: 40,
  },
  previewImageContainer: {
    position: 'absolute',
    left: 40,
    bottom: 120,
    height: 70,
    backgroundColor: 'transparent',
    marginBottom: 0,
    width: '100%',
    justifyContent: 'flex-start',
    flex: 1,
    flexWrap: 'wrap',
    flexDirection: 'row',
  },
  previewElement: {
    marginRight: 20,
  },
  previewImage: {
    width: 80,
    height: 80,
    borderRadius: 20,
  },
});

const Form = ({ onTextChange, onImageChange, draft, onImageRemove }) => {
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const [infoAttachmentsVisible, setInfoAttachmentsVisible] = useState(false);

  useEffect(() => {
    if (draft.text === undefined) {
      setEditorState(EditorState.createEmpty());
    }
  }, [draft]);

  function onEditorStateChange(newState) {
    setEditorState(newState);
    onTextChange(editorState.getCurrentContent().getPlainText());
  }

  function getImageFromCallback(url) {
    if (draft.images.length >= 4) {
      setInfoAttachmentsVisible(true);
      return;
    }
    onImageChange(url);
  }

  function deleteAttachment(valueToRemove) {
    onImageRemove(valueToRemove);
  }

  return (
    <View style={styles.container}>
      <View style={styles.formContainer}>
        <Editor
          toolbarHidden
          editorStyle={{
            height: 1000,
            padding: 15,
            fontFamily: 'Nunito_Regular',
          }}
          editorState={editorState}
          toolbarClassName="toolbarClassName"
          wrapperClassName="wrapperClassName"
          editorClassName="editorClassName"
          onEditorStateChange={onEditorStateChange}
          testID="text-field"
        />
      </View>
      <View style={styles.BottomTools}>
        <View style={styles.tools}>
          {/* <Image
            source={editTheme}
            style={styles.icon}
          /> */}
          <View style={styles.buttonContainer}>
            <CameraComponent parentCallback={getImageFromCallback} testID="selectImage" />
            <View style={draft.images.length > 3 ? styles.buttonDisabled : null} />
          </View>
          {/* <Image
            source={memo}
            style={styles.icon}
          /> */}
        </View>
        <View style={styles.previewImageContainer}>
          {draft.images.map((item, key) => (
            <View key={key.toString()} style={styles.previewElement}>
              <TouchableOpacity
                style={styles.deleteAttachment}
                onPress={() => deleteAttachment(item)}
                testID="deleteImage"
              >
                <View style={styles.deleteAttachmentIconContainer}>
                  <MaterialCommunityIcons
                    name="delete-circle"
                    style={styles.deleteAttachmentIcon}
                  />
                </View>
              </TouchableOpacity>
              <Image source={{ uri: item }} style={styles.previewImage} />
            </View>
          ))}
        </View>
      </View>
      {infoAttachmentsVisible && (
        <PopUpInfo
          description="Maximum number of attachments reached."
          button="OK"
          callback={() => setInfoAttachmentsVisible(false)}
          visability={infoAttachmentsVisible}
        />
      )}
    </View>
  );
};

export default Form;
